import type { AuditListResult, PersonalAuditListQuery, PersonalNotificationListResult } from "@packages/global";
import { httpClient } from "../httpClient";

class AccountActivityApi {
  async page(query: PersonalAuditListQuery): Promise<AuditListResult> {
    return httpClient.post<AuditListResult>("/account/activity/page", query);
  }

  async notifications(query: PersonalAuditListQuery): Promise<PersonalNotificationListResult> {
    return httpClient.post<PersonalNotificationListResult>("/account/activity/notifications/page", query);
  }

  async markNotificationRead(eventId: string): Promise<string[]> {
    return httpClient.post<string[]>("/account/activity/notifications/read", { eventId });
  }

  async markNotificationsRead(eventIds: string[]): Promise<string[]> {
    return httpClient.post<string[]>("/account/activity/notifications/read-batch", { eventIds });
  }
}

export const accountActivityApi = new AccountActivityApi();
